import { Button, DatePicker, Select, Space } from "antd";
import { ContentTopBar } from "components";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import { FininacalBookingGraphView } from "features/dashboard/components/finincal-booking/finincal-bboking-graph";
import { Fragment, useState } from "react";
dayjs.extend(customParseFormat);
dayjs.extend(timezone);

export const DashBoardFinancialBehaviourView = () => {
  const { RangePicker } = DatePicker;
  const currentDate = dayjs();
  const [selectedMonth, setSelectedMonth] = useState<string>(
    currentDate.format("MMM")
  );
  const [selectedFacilityId, setSelectedFacilityId] = useState<any>(null);
  const [selectedYear, setSelectedYear] = useState<number>(currentDate.year());
  const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>(
    [currentDate, currentDate]
  );

  const [appliedFilters, setAppliedFilters] = useState<{
    selectedMonth: string;
    selectedYear: number;
    dateRange: [dayjs.Dayjs, dayjs.Dayjs] | null;
    facilityId: string | null;
  }>({
    selectedMonth,
    selectedYear,
    dateRange,
    facilityId: null,
  });

  const years = [];
  for (let y = currentDate.year() - 10; y <= currentDate.year() + 5; y++) {
    years.push({ label: y.toString(), value: y });
  }

  const monthOptions = [
    { label: "All Month", value: "All" },
    ...dayjs.monthsShort().map((m) => ({ label: m, value: m })),
  ];

  return (
    <Fragment>
      <div className="facily_head">
        <ContentTopBar title="Financial & Booking " />
        <Space style={{ marginBottom: 16 }} className="filter_srch">
          <Select
            options={monthOptions}
            value={selectedMonth}
            allowClear={true}
            onChange={(value) => {
              setSelectedMonth(value);
              if (value !== null) {
                setDateRange(null); // Clear range picker when selecting a specific month
              }
            }}
            style={{ width: 120 }}
            placeholder="Select Month"
          />
          <Select
            options={years}
            value={selectedYear}
            onChange={(value) => {
              setSelectedYear(value);
              if (value !== null) {
                setDateRange(null); // Clear range picker when selecting a specific year
              }
            }}
            style={{ width: 120 }}
            placeholder="Select Year"
          />
          <RangePicker
            value={dateRange as any}
            onChange={(dates) =>
              setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs])
            }
            allowClear={true}
            disabled={selectedMonth === null} // disable range picker if "All" selected
          />
          <div className="filt_btn" style={{ display: "flex", gap: "10px" }}>
            <Button
              type="primary"
              onClick={() =>
                setAppliedFilters({
                  selectedMonth,
                  selectedYear,
                  dateRange,
                  facilityId: selectedFacilityId,
                })
              }
            >
              Filter
            </Button>

            <Button
              onClick={() => {
                const now = dayjs();
                const defaultMonth = now.format("MMM");
                const defaultYear = now.year();

                setSelectedMonth(defaultMonth);
                setSelectedYear(defaultYear);
                setDateRange([now, now]);
                setSelectedFacilityId(null);

                setAppliedFilters({
                  selectedMonth: defaultMonth,
                  selectedYear: defaultYear,
                  dateRange: [now, now],
                  facilityId: null,
                });
              }}
            >
              Cancel
            </Button>
          </div>
        </Space>

        <FininacalBookingGraphView
          selectedMonth={appliedFilters.selectedMonth}
          selectedYear={appliedFilters.selectedYear}
          dateRange={appliedFilters.dateRange}
          facilityId={appliedFilters.facilityId}
        />
      </div>
    </Fragment>
  );
};
